"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMockBulkDownloadTaskStatus = exports.createMockCreateBulkDownload = exports.createMockGetBulkDownloadFileList = void 0;
const common_1 = require("@hum/common");
const types_1 = require("@hum/types");
const faker_1 = require("@faker-js/faker");
const createMockGetBulkDownloadFileList = (overwrites = {}) => (Object.assign({ customerFiles: [
        {
            companyId: faker_1.faker.datatype.number(),
            createdAt: faker_1.faker.date.recent().toISOString(),
            createdBy: faker_1.faker.datatype.number(),
            documentType: (0, common_1.randomlySelectEnum)(types_1.CompanyFileDocumentType),
            ext: faker_1.faker.system.fileExt(),
            fileType: faker_1.faker.system.fileType(),
            id: faker_1.faker.datatype.number(),
            ingestedAt: faker_1.faker.date.recent().toISOString(),
            ingestionStatus: (0, common_1.randomlySelectEnum)(types_1.FileStatus),
            isExternal: faker_1.faker.datatype.boolean(),
            meta: {},
            name: faker_1.faker.system.fileName({ extensionCount: 0 }),
            potentiallyInvalid: faker_1.faker.datatype.boolean(),
            sourcePath: faker_1.faker.system.filePath(),
            sourceUrl: faker_1.faker.internet.url(),
            status: (0, common_1.randomlySelectEnum)(types_1.FileStatus),
            updatedAt: faker_1.faker.date.recent().toISOString(),
        },
    ], supportedFinancialDocuments: [
        {
            connectorSource: (0, common_1.randomlySelectEnum)(types_1.ConnectorSource),
            connectorType: (0, common_1.randomlySelectEnum)(types_1.ConnectorType),
            docType: (0, common_1.randomlySelectEnum)(types_1.CompanyFileDocumentType),
            lastSuccessPullAt: faker_1.faker.date.recent().toISOString(),
        },
    ] }, overwrites));
exports.createMockGetBulkDownloadFileList = createMockGetBulkDownloadFileList;
const createMockCreateBulkDownload = (overwrites = {}) => (Object.assign({ state: (0, common_1.randomlySelectObjectValue)(types_1.BulkDownloadStatus), taskId: faker_1.faker.datatype.uuid() }, overwrites));
exports.createMockCreateBulkDownload = createMockCreateBulkDownload;
const createMockBulkDownloadTaskStatus = (overwrites = {}) => (Object.assign({ state: (0, common_1.randomlySelectObjectValue)(types_1.BulkDownloadStatus), fileUrl: faker_1.faker.internet.url() }, overwrites));
exports.createMockBulkDownloadTaskStatus = createMockBulkDownloadTaskStatus;
//# sourceMappingURL=BulkDownload.factory.js.map